<template>
    <div class="animated-bg">
        <div class="background-img">
            <div class="overlay"></div>
            <div class="sections-title-container">
                <div class="center-col-direction-flex">
                    <h1>شركة بيترونكس للحلول البرمجية والالكترونية</h1>
                </div>
                <div class="sections-container">
                    <div class="loader" v-if="loading">
                        <i class="fa fa-spin fa-circle-o-notch"></i>
                    </div>
                    <div v-for="item in sections.concat().reverse()" v-bind:key="item.Id"
                         class="animated zoomIn  section">
                        <router-link :to="{ name: 'products', params: { section: item.Title } }">
                            <img :src="item.Image.Url">
                            <span>{{ item.Title }}</span>
                            <div class="border-underline"></div>
                        </router-link>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        name: "AnimatedBackground",
        data() {
            return {
                sections: [],
                loading: true,
            }
        },

        mounted() {
            axios.get(apiHost + "/sections")
                .then((response) => {
                    this.sections = response.data;
                })
                .catch((error) => console.log(error))
                .finally(() => this.loading = false);
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/assets/sass/shared.scss";

    .animated-bg {
        width: 100%;
        overflow: hidden;
        position: relative;
        top: 0px;
        &:before{
            
        }

        .background-img {
            position: relative;
            text-align: center;
            overflow:hidden;
            width:100%;
            &:before{
            content: "";
            position:absolute;
            top:0px;
            left:0px;
            width:200%;
            background: url('/src/assets/img/pexels-photo-216632.jpeg') no-repeat;
            z-index: 0;
            min-height: 650px;
            background-size:cover;
            background-position: top bottom;
            @include transition(transform linear 50s);
            @include animation-name(MovingParallax);
            @include animation-duration(70s);
            @include animation-timing-function(linear);
            @include animation-iteration-count(infinite);
            }
           
            @media(max-width: 345px) {
                min-height: 750px;
            }

            .overlay {
                @include overlay-layer(rgba(0, 0, 0, 0.5));
            }
            .sections-title-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                min-height: 650px;
                @media(max-width: 767px) {
                    justify-content: flex-end;
                }
                @media(max-width: 345px) {
                    min-height: 750px;
                }

                .loader {
                    font-size: 50px;
                    margin: 50px auto;
                    color: #f9a020;
                }
            }
            .center-col-direction-flex {
                position: relative;
                width: 100%;

                h1 {
                    font-size: 40px;
                    color: #fff;
                    margin: 0px 0px 20px;
                    @media(max-width: 767px) {
                        margin-bottom: 10px;
                        font-size: 30px;
                    }
                }

            }
            .sections-container {
                margin-bottom: 20px;
                display: flex;
                position: absolute;
                bottom: 10px;
                width: 100%;
                z-index: 1;
                text-align: center;
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: center;
                @media(max-width: 767px) {
                    position: relative;
                    bottom: unset;
                }
                .section {
                    width: 140px;
                    text-align: center;
                    display: inline;
                    margin-left: 20px;
                    margin-right: 20px;
                    border-radius: 5px;
                    @include transition(all ease 2s);
                    @media(max-width: 990px) {
                        width: 100px;
                    }
                    @media(max-width: 767px) {
                        width: 120px;
                    }
                    @media(max-width: 480px) {
                        width: 100px;
                    }
                    @media(max-width: 480px) {
                        width: 75px;

                    }
                    &:hover {
                        background-color: rgba(255, 255, 255, 0.33);
                    }
                    &:hover .border-underline {
                        width: 90%;
                    }
                    @include animation-fill-mode(backwards);
                    a {
                        color: white;
                        padding: 12px;

                        text-decoration: none;
                        margin: 0px 5px;
                        @include transition(all ease 1s);
                        img {
                            display: block;
                            margin: 10px auto;
                            width: 100%;
                            height: auto;
                        }
                        .border-underline {
                            border-top: 1px solid white;
                            margin: 5px auto;
                            width: 0%;
                            @include transition(width ease 0.4s);
                        }

                    }
                }
            }

        }

    }

    @include keyframes(MovingParallax) {
        0% {
            @include prefixer(transform,translateX(0%),("moz","webkit","ms","o"));
        }
        25% {
            @include prefixer(transform,translateX(-12%),("moz","webkit","ms","o"));
            
        }
        50% {
            @include prefixer(transform,translateX(-25%),("moz","webkit","ms","o"));
        }
        75% {
            @include prefixer(transform,translateX(-37.5%),("moz","webkit","ms","o"));
        }
        100% {
            @include prefixer(transform,translateX(-50%),("moz","webkit","ms","o"));
            
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/home/animated-background.vue